import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import Product from "./Product";
import FeaturedProductSlider from "./FeaturedProductsSlider";

function FeaturedItems(props) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState(props.containerObject && props.containerObject.attributes && props.containerObject.attributes.title ? props.containerObject.attributes.title : "")
  const [titleCss, setTitleCss] = useState(props.containerObject && props.containerObject.attributes && props.containerObject.attributes.titleCss ? props.containerObject.attributes.titleCss : "")
  const [containerObject, setContainerObject] = useState(props.containerObject ? props.containerObject : "")
  const [productDetailsItems, setProductDetailsItems] = useState([])
  const [loader, setLoader] = useState(false)


  return (
    <>
      {loader ? <Loader /> : ""}
      <div className={`${containerObject && containerObject.attributes && containerObject.attributes.className ? containerObject.attributes.className : ""}`}>
        {/* <div className="featured-items-heading d-flex"> */}
        <div className={titleCss ? titleCss : "featuredProductTitileCss"}>
          <h4>{title}</h4>
          {/* <div dangerouslySetInnerHTML={{__html:title}} ></div> */}
        </div>
        <div className="row featured-items-list ms-1 col-md-12 mt-4 mb-4 d-lg-block d-none">
          <ul className="row p-0">
            <Product containerObject={containerObject ? containerObject : ""} />
          </ul>
        </div>
        <div className="row featured-items-list ms-1 col-md-12 mt-4 mb-4 d-lg-none d-block">
          <ul className="row">
            <FeaturedProductSlider containerObject={containerObject} hideTitle={true} />
          </ul>
        </div>
      </div >
    </>
  );
}

export default FeaturedItems;